<template>
  <div>
    <div class="outlineContainer" @click="onClick" v-if="getListOfUser.length>0">
      <w-tool-tip :label="isPrivate?$t('generic.weetVisibility.private'):$t('generic.weetVisibility.semiPrivate')">
        <w-icon :icon="isPrivate?'lock-outline':'link'" color="black" class="visiblityIcon" size="small"/>
      </w-tool-tip>
      <UserAvatar size="tiny" v-for="user in getListOfUser"
                  :user-avatar="getAvatarForUser(user)" class="avatarUser"
                  tooltip-position="top" :key="'userButtonAvatar'+user.userID"/>
      ({{ numberOfUser }})
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Weet} from '@/store/weet/weetModel';
import UserAvatar from '@/components/user/UserAvatar.vue';
import {Channel, ChannelSubscription} from '@/store/channel/channelModel';
import store from '@/store';
import {GET_LIST_OF_SUBSCRIBER} from '@/store/channel/channelAction';
import {PaginationWrapper} from '@/store/generic/paginationWrapper';
import {User} from '@/store/user/userModel';
import {getUserAvatar} from '@/utils/util';
import {log} from '@/utils/log';
import WIcon from '@/components/wrapper/w-icon.vue';
import {VisibilityPolicy} from '@/store/weet/VisibilityPolicy';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import {VisibilityChannelPolicy} from '@/store/channel/VisibilityChannelPolicy';
import {GET_WEET_PEOPLES} from '@/store/weet/weetAction';
import {shuffle} from 'lodash';
import WButton from '@/components/wrapper/w-button.vue';

@Component({
  components: {WButton, WToolTip, WIcon, UserAvatar},
})
export default class ButtonUsers extends Vue {
  @Prop()
  private weet!: Weet;

  @Prop()
  private channel!: Channel;

  @Prop({default: 3})
  private maxUser!: number;

  private numberOfUser: number = 0;

  private mustShow: boolean = false;

  private listOfUser: any = {};

  private loading: boolean = false;

  public mounted() {
    this.mustShow = true;
    this.loadUsers();
  }

  public loadUsers() {
    if (this.weet) {
      this.loadUserForAWeet();
    } else if (this.channel) {
      this.loadUserForAChannel();
    }
  }

  get isAuthenticated(): boolean {
    return store.getters.isAuthenticated;
  }

  get isPrivate(): boolean {
    if (this.weet) {
      return this.weet.visibilityPolicy === VisibilityPolicy.INTERNAL;
    } else if (this.channel) {
      return this.channel.visibilityPolicy === VisibilityChannelPolicy.PRIVATE;
    }
    return false;
  }

  get getListOfUser(): User[] {
    return Object.values(this.listOfUser);
  }

  private onClick() {
    this.$emit('click');
  }

  private getAvatarForUser(user: User): string {
    return getUserAvatar(user, 96);
  }

  private getUserFirstNameTooltip(user: User): string {
    return user.firstName;
  }

  private getUserLastNameTooltip(user: User): string {
    return user.lastName;
  }

  private loadUserForAChannel() {
    if (Object.values(this.listOfUser).length < this.maxUser) {
      if (this.isAuthenticated) {
        this.loading = true;
        this.listOfUser = [];
        this.numberOfUser = 0;
        store.dispatch(GET_LIST_OF_SUBSCRIBER, this.channel).then((data: PaginationWrapper) => {
          for (const sub of shuffle(data.data) as ChannelSubscription[]) {
            if (Object.values(this.listOfUser).length < this.maxUser) {
              Vue.set(this.listOfUser, sub.user.userID, sub.user);
            }
          }
          this.numberOfUser = data.count;
          this.loading = false;
        }).catch((e) => {
          log.warn('don\'t have access to this subscribe list');
        });
      }
    }

  }

  private loadUserForAWeet() {
    if (this.isAuthenticated) {
      this.loading = true;
      store.dispatch(GET_WEET_PEOPLES, this.weet.weetID).then((data: PaginationWrapper) => {
        this.listOfUser = [];
        this.numberOfUser = 0;
        for (const user of shuffle(data.data) as User[]) {
          if (Object.values(this.listOfUser).length < this.maxUser) {
            Vue.set(this.listOfUser, user.userID, user);
          }
        }
        this.numberOfUser = data.count;
        this.loading = false;
      }).catch((e) => {
        log.warn('don\'t have access to this subscribe list');
      });
    }
  }


}
</script>

<style scoped lang="scss">
@import '@/scss/gridBreakPoint.scss';
@import '@/scss/shadows.scss';

.outlineContainer {
  border: solid 1px var(--light1);
  padding: 4px;
  color: var(--black);
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  padding-left: 8px;
  font-weight: 500;
  max-height: 32px;
  align-items: center;

  &:hover {
    border: solid 1px var(--light2);
  }

  .visiblityIcon {
    margin-right: 16px;
  }

  .avatarUser {
    margin-left: -12px;
    margin-right: 4px;
  }
}
</style>
